import React from 'react';
import { Helmet } from 'react-helmet';
import { isProduction } from '../../../common/utils/environment-util';

const stagingScript = (
  <Helmet>
    <script src="https://cdn-apac.onetrust.com/consent/a3be3527-7455-48e0-ace6-557ddbd506d5-test/OtAutoBlock.js" />
    <script
      src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
      data-document-language="true"
      type="text/javascript"
      data-domain-script="a3be3527-7455-48e0-ace6-557ddbd506d5-test"
    />
    <script type="text/javascript">{'function OptanonWrapper() {}'}</script>
  </Helmet>
);

const productionScripts = (
  <Helmet>
    <script src="https://cdn-apac.onetrust.com/consent/a3be3527-7455-48e0-ace6-557ddbd506d5/OtAutoBlock.js" />
    <script
      src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"
      data-document-language="true"
      type="text/javascript"
      data-domain-script="a3be3527-7455-48e0-ace6-557ddbd506d5"
    />
    <script type="text/javascript">{'function OptanonWrapper() {}'}</script>
  </Helmet>
);

const CookieBanner = () => {
  const isPrd = isProduction();
  return isPrd ? productionScripts : stagingScript;
};

export default CookieBanner;
